import { Link } from "react-router-dom";

const WD = ["SEG", "TER", "QUA", "QUI", "SEX"];
const CHIP = { green: "bg-emerald-50 text-emerald-700", amber: "bg-amber-50 text-amber-800", red: "bg-red-50 text-red-700" };
const DOT = { green: "bg-emerald-500", amber: "bg-amber-500", red: "bg-red-600" };
const box = "bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgb(0,0,0,0.04)] p-5";
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

function Strip({ items }) {
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const mon = new Date(t); mon.setDate(t.getDate() - ((t.getDay() + 6) % 7));
  const days = WD.map((w, i) => { const d = new Date(mon); d.setDate(mon.getDate() + i); return { w, d, k: iso(d) }; });
  return (
    <div className="grid grid-cols-5 gap-1.5 mt-3" data-testid="gp-week-strip">
      {days.map(({ w, d, k }) => {
        const here = items.filter((a) => a.date === k);
        const today = k === iso(t);
        return (
          <div key={k} className={`rounded-xl py-2 text-center border ${today ? "navy-bg text-white border-transparent" : "border-slate-100 text-slate-700"}`} data-testid={`gp-week-${k}`}>
            <div className="text-[11px] font-semibold opacity-80">{w}</div><div className="text-lg font-bold leading-tight">{d.getDate()}</div>
            <div className="h-2 flex justify-center gap-0.5">{here.slice(0, 3).map((a) => <span key={`${a.pid}-${a.kind}`} title={a.kind === "CPCV" ? "CPCV" : "Escritura"} className={`w-1.5 h-1.5 rounded-full ${a.kind === "CPCV" ? "bg-violet-500" : today ? "bg-white" : "bg-slate-900"}`} />)}</div>
          </div>
        );
      })}
    </div>
  );
}

export function WeekAgenda({ items }) {
  const days = [...new Set(items.map((a) => a.day))];
  return (
    <div className={box} data-testid="gp-agenda">
      <div className="flex items-baseline justify-between"><h2 className="text-lg font-semibold navy-text">Esta semana</h2><Link to="/escrituras" className="text-sm text-slate-500 hover:underline" data-testid="gp-agenda-month">Ver mês →</Link></div>
      <Strip items={items} />
      <div className="flex gap-4 mt-2 text-xs text-slate-500"><span className="inline-flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-violet-500" />CPCV</span><span className="inline-flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-slate-900" />Escritura</span></div>
      {!items.length && <p className="text-sm text-slate-500 mt-3">Sem CPCVs nem escrituras nos próximos 7 dias.</p>}
      <div className="mt-2 border-l-2 border-slate-100 ml-1">
        {days.map((day) => (
          <div key={day} className="pl-4 mt-3">
            <div className="text-xs font-bold tracking-wider text-slate-500 uppercase">{day}</div>
            {items.filter((a) => a.day === day).map((a) => (
              <Link key={`${a.pid}-${a.kind}`} to={`/processo/${a.pid}`} className="relative flex items-start gap-3 py-2 hover:bg-slate-50 rounded-lg" data-testid={`gp-agenda-${a.pid}-${a.kind}`}>
                <span className={`absolute -left-[21px] top-3.5 w-2 h-2 rounded-full ${DOT[a.tone]}`} />
                <span className="w-11 shrink-0 tabular-nums text-sm font-semibold text-slate-700" data-testid={`gp-agenda-time-${a.pid}-${a.kind}`}>{a.time ? a.time.replace(":", "h") : "—"}</span>
                <span className="flex-1 min-w-0"><span className="block text-[15px] text-slate-900"><b>{a.kind === "CPCV" ? "CPCV" : "Escritura"}</b> · {a.short}</span>
                  <span className="block text-sm text-slate-500" data-testid={`gp-agenda-place-${a.pid}-${a.kind}`}>{[a.place || (a.firm ? null : "Data prevista"), a.consultant].filter(Boolean).join(" · ")}</span>
                  {!a.firm && <span className="inline-block mt-0.5 text-xs font-semibold text-red-700">{!a.time && !a.place ? "Falta hora e local" : !a.time ? "Falta hora" : "Falta local"}</span>}</span>
                <span className={`shrink-0 px-2 py-0.5 rounded-full text-xs font-semibold ${CHIP[a.tone]}`}>{a.chip}</span>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function Compliance({ d }) {
  const { pep, kyc = [], kyc_on, areas = [] } = d.compliance;
  const row = (label, n, to, tid) => (
    <div className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-0" data-testid={tid}>
      <span className="text-[15px] text-slate-700">{label}</span>
      {to ? <Link to={to} className="text-sm font-semibold navy-text hover:underline">{n}</Link> : <span className={`font-semibold ${n ? "text-amber-700" : "text-emerald-600"}`}>{n}</span>}
    </div>
  );
  return (
    <div className={box} data-testid="gp-compliance">
      <h2 className="text-lg font-semibold navy-text mb-1">Compliance</h2>
      {kyc_on && row("Fichas de identificação em falta", kyc.length, kyc[0] && `/processo/${kyc[0].pid}`, "gp-kyc")}
      {row("Cargos públicos por aprovar", pep.length, pep[0] && `/processo/${pep[0].pid}`, "gp-pep")}
      {row("Áreas diferentes por resolver", areas.length, areas[0] && `/processo/${areas[0].pid}#sec-imovel`, "gp-areas")}
      <div className="flex items-center justify-between py-2.5"><span className="text-[15px] text-slate-700">Próxima comunicação ao IMPIC</span><Link to="/obrigacoes" className="text-sm font-semibold navy-text hover:underline" data-testid="gp-impic">Ver resumo</Link></div>
    </div>
  );
}
